var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgComments(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    width: 512,
    height: 512
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 16v5a3 3 0 01-3 3h-5a8 8 0 01-6.92-4 10.968 10.968 0 002.242-.248A5.988 5.988 0 0016 22h5a1 1 0 001-1v-5a5.988 5.988 0 00-2.252-4.678A10.968 10.968 0 0020 9.08 8 8 0 0124 16zm-6.023-6.349A9 9 0 008.349.023 9.418 9.418 0 000 9.294v5.04C0 16.866 1.507 18 3 18h5.7a9.419 9.419 0 009.277-8.349zm-4.027-5.6a7.018 7.018 0 012.032 5.46A7.364 7.364 0 018.7 16H3c-.928 0-1-1.275-1-1.666v-5.04a7.362 7.362 0 016.49-7.276Q8.739 2 8.988 2a7.012 7.012 0 014.962 2.051z"
  })));
}
export default SvgComments;